import React from 'react'
import notification from '../../images/appreciation/notification.png';
import assignment from '../../images/appreciation/assignment.png';
import onlineclass from '../../images/appreciation/onlineclass.png';
import study from '../../images/appreciation/study.png';
import calendar from '../../images/appreciation/calendar.png';
import routine from '../../images/appreciation/routine.png';
import attendance from '../../images/appreciation/attendance.png';
import report from '../../images/appreciation/report.png';
import suggestion from '../../images/appreciation/suggestion.png';
import gallery from '../../images/appreciation/gallery.png';
import reportcard from '../../images/appreciation/reportcard.png';
import leavenote from '../../images/appreciation/leavenote.png';
import settings from '../../images/appreciation/settings.png';
import budget from '../../images/appreciation/budget.png';
import google from '../../images/google.png';
import apple from '../../images/app.png';
import { useEffect } from 'react';
import Aos from 'aos';

const Features = () => {

    useEffect(() => {
        Aos.init();
    }, []);

    const items = [
        {
            name: "Profile",
            logo: notification
        },
        {
            name: "Assignment",
            logo: assignment
        },
        {
            name: "Online Class",
            logo: onlineclass
        },
        {
            name: "Study Material",
            logo: study
        },
        {
            name: "Event",
            logo: calendar
        },
        {
            name: "Routine",
            logo: routine
        },
        {
            name: "Attendance",
            logo: attendance
        },
        {
            name: "Account",
            logo: report
        },
        {
            name: "Suggestion",
            logo: suggestion
        },
        {
            name: "Gallery",
            logo: gallery
        },
        {
            name: "Report Card",
            logo: reportcard
        },
        {
            name: "Notification",
            logo: notification
        },
        {
            name: "Leave Note",
            logo: leavenote
        },
        {
            name: "Fee Payment",
            logo: settings
        },
        {
            name: "Blog",
            logo: budget
        },
        {
            name: "Cafeteria",
            logo: budget
        },
        {
            name: "Library",
            logo: budget
        },

    ]


    return (
        <>

            <section id="admin" className="features">
                <div className="container">

                    <div className="section-title" data-aos="fade-up"
                        data-aos-anchor-placement="center-bottom" data-aos-duration="3000">
                        <h2>Features of  <span style={{ color: "red" }}> Easy </span> School App</h2>
                    </div>
                    <div className="new-features" data-aos="fade-up"
                        data-aos-duration="3000">

                        {items.map((item, i) => (

                            <div className='className--div' key={i}>
                                <div className="new-features-img-div">
                                    <img src={item.logo} alt="logo" className="new-features-image" />
                                </div>

                                <p className="new-features-name">{item.name}</p>
                            </div>

                        ))}

                    </div>


                    <div className="download-section" data-aos="fade-up"
                        data-aos-anchor-placement="center-bottom" data-aos-duration="3000">
                        <h4>Now Available On</h4>
                        <h3>Download App</h3>
                        <p> Easy School app is personalized app for your school’s calendar, timetable,Activities and identity with the school and logo, and has a direct link to the school website. It will also receive push
                            notifications sent by your school administrators to remind you of upcoming events, let you know about schedule changes, advise you of school closures, and other news.</p>

                        <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=easysoft.com.easyschool"> <img className="google-down mr-3" src={google} alt="google" /></a>
                        <a target="_blank" rel="noreferrer" href="https://apps.apple.com/np/app/easy-school-apps/id1461107075"><img className="google-down" src={apple} alt="apple" /></a>
                        {/* <a target="_blank" rel="noreferrer" href="https://esnep.com/student" className="download-btn"><GoGlobe className="i" />Web App</a> */}
                    </div>
                </div>
            </section>


            {/* <section id="student" className="features">
                <div className="container">

                    <div className="section-title" data-aos="fade-up">
                        <h2>Easy School for Student</h2>

                        <a target="_blank" href="https://play.google.com/store/apps/details?id=easysoft.com.easyschool" className="download-btn"><FaGooglePlay className="i" />Android App</a>
                        <a target="_blank" href="https://apps.apple.com/np/app/easy-school-apps/id1461107075" className="download-btn"><FaApple className="i" /> IOS App</a>
                        <a target="_blank" href="https://esnep.com/student" className="download-btn"><GoGlobe className="i" />Web App</a>
                        <p className="mt-3"><font style={{ color: "#349", fontWeight: "bold", fontSize: "16px" }}>For Demo (Android & IOS & Web) :</font> <font style={{ fontSize: "16px", color: "#444444" }}> School ID : PS0011 | Username : PS1015 | Password : PS1015</font> </p>
                        <p className="mt-3" style={{ fontSize: "16px", color: "#444444" }}>Features for Student</p>
                    </div>

                    <div className="row" data-aos="fade-up" data-aos-delay="300">
                        <div className="col-lg-3 col-md-4">
                            <div className="icon-box">
                                <i className="ri-store-line" ></i>
                                <h3><a>Class Routine</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">
                                <i className="ri-bar-chart-box-line" ></i>
                                <h3><a>Exam Routine</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">
                                <i className="ri-calendar-todo-line" ></i>
                                <h3><a>Report Card</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                            <div className="icon-box">
                                <i className="ri-paint-brush-line" ></i>
                                <h3><a>Account</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-database-2-line" ></i>
                                <h3><a>Online Class</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-gradienter-line" ></i>
                                <h3><a>Fee Payment</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-file-list-3-line" ></i>
                                <h3><a>Assignment</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-price-tag-2-line"></i>
                                <h3><a>Attendance</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-anchor-line" ></i>
                                <h3><a>Leavenote</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-disc-line" ></i>
                                <h3><a>Appreciation</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-base-station-line" ></i>
                                <h3><a>Bus Route</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-fingerprint-line" ></i>
                                <h3><a>Notice</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-anchor-line" ></i>
                                <h3><a>Upcoming Event</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-disc-line" ></i>
                                <h3><a>Study Material</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-base-station-line" ></i>
                                <h3><a>Video</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-fingerprint-line"></i>
                                <h3><a>Gallery</a></h3>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section id="teacher" className="features">
                <div className="container">

                    <div className="section-title" data-aos="fade-up">
                        <h2>Easy School for Teacher</h2>

                        <a target="_blank" href="https://play.google.com/store/apps/details?id=easysoft.com.easyschool" className="download-btn"><FaGooglePlay className="i" />Android App</a>
                        <a target="_blank" href="https://apps.apple.com/np/app/easy-school-apps/id1461107075" className="download-btn"><FaApple className="i" /> IOS App</a>
                        <a target="_blank" href="https://esnep.com/student" className="download-btn"><GoGlobe className="i" />Web App</a>
                        <p className="mt-3"><font style={{ color: "#349", fontWeight: "bold", fontSize: "16px" }}>For Demo (Android & IOS & Web) :</font> <font style={{ fontSize: "16px", color: "#444444" }}> School ID : PS0011 | Username : PS1626 | Password : PS1626</font> </p>
                        <p className="mt-3" style={{ fontSize: "16px", color: "#444444" }}>Features for Teacher</p>
                    </div>

                    <div className="row" data-aos="fade-up" data-aos-delay="300">
                        <div className="col-lg-3 col-md-4">
                            <div className="icon-box">
                                <h3><a>Class Routine</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">
                                <h3><a>Assignment</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">

                                <h3><a>Attendance</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                            <div className="icon-box">

                                <h3><a>Online Class</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Leavenote</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Appreciation</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Notice</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Upcoming Event</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Online Exam</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Study Material</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Video</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Gallery</a></h3>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section id="admin" className="features">
                <div className="container">

                    <div className="section-title" data-aos="fade-up">
                        <h2>Easy School for Admin</h2>

                        <a target="_blank" href="https://play.google.com/store/apps/details?id=easysoft.com.easyschool" className="download-btn"><FaGooglePlay className="i" />Android App</a>
                        <a target="_blank" href="https://apps.apple.com/np/app/easy-school-apps/id1461107075" className="download-btn"><FaApple className="i" /> IOS App</a>
                        <a target="_blank" href="https://esnep.com/student" className="download-btn"><GoGlobe className="i" />Web App</a>

                        <p className="mt-3"><font style={{ color: "#349", fontWeight: "bold", fontSize: "16px" }}>For Demo (Android & IOS & Web) :</font> <font style={{ fontSize: "16px", color: "#444444" }}> School ID : PS0011 | Username : PS1625 | Password : PS1625</font> </p>
                        <p className="mt-3" style={{ fontSize: "16px", color: "#444444" }}>Features for Admin</p>
                    </div>
                    <div className="row" data-aos="fade-up" data-aos-delay="300">
                        <div className="col-lg-3 col-md-4">
                            <div className="icon-box">

                                <h3><a>Routine</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">

                                <h3><a>Summary</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">

                                <h3><a>Report</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                            <div className="icon-box">

                                <h3><a>Attendance</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Leavenote</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Assignment</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Online Class</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Bulk SMS</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Notice</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Upcoming Event</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Study Material</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">

                                <h3><a>Video</a></h3>
                            </div>
                        </div>

                    </div>

                </div>
            </section> */}


        </>
    )
}

export default Features